import { render, staticRenderFns } from "./yi_card_reader.vue?vue&type=template&id=6b6ffa18&scoped=true&"
import script from "./yi_card_reader.vue?vue&type=script&lang=js&"
export * from "./yi_card_reader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ffa18",
  null
  
)

export default component.exports